export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/964b7627ac32b1667e9737bde2457a01.jpg"
          alt="Premium Laundry Service"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="inline-flex items-center gap-2 bg-amber-600/20 backdrop-blur-sm border border-amber-400/30 px-5 py-2 rounded-full mb-6">
          <i className="ri-shopping-bag-3-line text-amber-400 text-lg"></i>
          <span className="text-sm font-medium text-white">Bulk Orders Only</span>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm px-5 py-2.5 rounded-full mb-8 border border-amber-200">
              <i className="ri-sparkling-fill text-amber-600 text-lg"></i>
              <span className="text-sm font-medium text-gray-800">Premium Laundry Care Since 2010</span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Golden Dry Cleaning<br />
              and Laundry Services
            </h1>

            <p className="text-lg text-gray-200 mb-10 max-w-xl mx-auto lg:mx-0">
              Experience exceptional dry cleaning and laundry services with eco-friendly practices, convenient pickup and delivery, and meticulous attention to every detail.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-amber-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-amber-700 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                Book Service Now
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
              >
                View Pricing →
              </button>
            </div>
          </div>

          <div className="lg:w-2/5">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Perfectly%20folded%20pristine%20white%20luxury%20linens%20and%20towels%20stacked%20neatly%20on%20wooden%20surface%2C%20professional%20laundry%20service%20quality%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%20with%20golden%20hour%20warmth%2C%20high-end%20fabric%20care%20results%2C%20crisp%20pressed%20sheets%20with%20visible%20texture%20details%2C%20commercial%20photography%20style&width=600&height=700&seq=hero-img-001&orientation=portrait"
                alt="Premium Folded Linens"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
